export const DAMAGE_MECHANISM_MAPPING: { [key: string]: string } = {
  ISOLATED_CORROSION: 'Isolated Corrosion',
  EROSION_CORROSION: 'Erosion/Corrosion',
  MICRO_PITTING: 'Micro Pitting',
  CRACKING: 'Cracking',
  HIC: 'HIC',
  SOHIC: 'SOHIC',
  SSC: 'SSC',
  SCC: 'SCC',
  HTHA: 'HTHA',
  FATIGUE_CRACKING: 'Fatigue Cracking',
  LAMINATION: 'Lamination',
  INCLUSION: 'Inclusion',
  UNKNOWN: 'Unknown',
  OTHER: 'Other',
  THINNING: 'Thinning',
  PITTING: 'Pitting',
  PLANAR_CRACK: 'Planar Crack',
  TRANSVERSE_CRACK: 'Transverse Crack',
  COLD_JOINT: 'Cold Joint',
  VOID: 'Void',
  HONEYCOMB: 'Honeycomb',
  DEBONDING: 'Debonding',
  DELAMINATION: 'Delamination',
  POROSITY: 'Porosity',
  LACK_OF_FUSION: 'Lack of Fusion',
  SLAG_INCLUSION: 'Slag Inclusion',
  CRACK: 'Crack',
  INCOMPLETE_PENETRATION: 'Incomplete Penetration',
  NOISE: 'Noise',
  GEOMETRY: 'Geometry',
  TRAILING_ECHO: 'Trailing Echo',
  MODE_CONVERSION: 'Mode Conversion',
  DEFECT: 'Defect',
}
